export default {
  segment_labels: {
    active: 'En cours',
    cancelled: 'Annulées',
    completed: 'Terminées',
  },
};
